import _get from "lodash/get";
import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import HosContent from "./HosContent";
import ProgressBar from "../../../components/ProgressBar";

export class HosContainer extends React.Component {
    render() {
        return (
            <div>
                <Row>
                    <Col xs="12">
                        <ProgressBar percentage={90} />
                    </Col>
                    <Col xs="12">
                        <HosContent />
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        business: _get(state, "appData.business", {})
    };
};
export default withRouter(
    connect(
        mapStateToProps,
        {}
    )(HosContainer)
);
